module.exports = __webpack_public_path__ + "img/no_msg.d54cbb28.svg";